































































































import { Component, Vue, Prop, Watch, Mixins } from 'vue-property-decorator';
import { vxm } from '../../store.vuex';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import Multiselect from 'vue-multiselect';
import { Language } from '@/models/userdata/language';
import ProfilePlaceholder from '@/components/Commons/ProfilePlaceholder.vue';
import AddEntity from '@/components/Commons/AddEntity.vue';
import GuidedSignupUtilities from '@/components/GuidedSignup/utilities';


Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});
declare var window:any;
@Component({
  name: 'MyProfileDetails',
  components: {
    Multiselect,
    ProfilePlaceholder,
    AddEntity,
  },
})
export default class MyProfileDetails  extends Mixins(GuidedSignupUtilities) {
  $wlToastr: any;
  private viewMode: boolean = true;
  private selectedLanguage: string[] = [];
  private userSelectedLanguages: string[] = [];
  private languageArray = [];

  @Prop({ default: () => new Vue(), type: Vue }) bus;
  @Prop() isRequiredStep; 
  @Prop() minimumEntries;
  @Prop() isLastStep;

  // Added watcher for userSelectedLanguages
  @Watch('userSelectedLanguages')
  onUserSelectedLanguagesChange(newValue: string[], oldValue: string[]) {
    this.updateNextButtonState(); 
  }

  // Added method to update next button state based on minimum entries
  updateNextButtonState() {
    const shouldDisableNextButton = this.minimumEntries > this.userSelectedLanguages.length;
    this.$emit('disable-next-button', this.isRequiredStep && shouldDisableNextButton);
  }

  editLanguage() {
    this.viewMode = false;
  }
  get sectionSubHeader(){
    if( this.minimumEntries>1 && this.userPermissionConfig('edit')){
      return `Please add at least ${
          this.minimumEntries
        } languages`
    }
   return ''
 }

 get isConfigEnabled(){
      if(window.WorkLLama.isConfigJSONEnabled==='true'){
        return true
      }
      return false
      }
  userPermissionConfig(permission){
    return vxm.configs.getUserPermissionConfig(permission,'LANGUAGE');
  }

  get sectionName() {
    if (this.$route.name && this.$route.name === 'GuidedSignup') {
      const section = vxm.configs.ClientConfigs.profileWizardConfig.profileSections.find(
        (section) => section.sectionKey === 'LANGUAGE',
      );
      return section ? section.displayName : 'Languages';
    }
    const section = vxm.configs.ClientConfigs.userProfileConfig.profileSections.find(
      (section) => section.sectionKey === 'LANGUAGE',
    );
    return section ? section.displayName : 'Languages';
  }

  cancelChanges(index) {
    this.userSelectedLanguages = [...this.selectedLanguage];
    this.viewMode = true;
  }
  mounted() {
    this.fetchSelectedLanguages();
    this.fetchAllLanguages();
    this.bus.$on('on-next-step', this.updateChanges);
    this.updateNextButtonState();
    this.viewMode = this.isMyProfile;
  }

  updateChanges() {
    const language = new Language();
    language.languages = [...this.userSelectedLanguages];
    this.saveLanguage(language);
    this.updateNextButtonState();
  }

  beforeDestroy() {
    this.bus.$off('on-next-step');
  }

  get isMyProfile() {
    if(this.$router.currentRoute.name === 'GuidedSignup'){
        this.viewMode = false;
        if(!this.userPermissionConfig('add')){
          this.viewMode = true;
        }
        return this.viewMode
    }
    else{
         return this.$router.currentRoute.name === 'Language';
    }
  }

  saveLanguage(language: Language) {
    const vm = this;
    const respPromise: any = vxm.users.updateLanguage(language);
    Promise.all([respPromise])
      .then(async (values) => {
        if (values[0].meta.success === false) {
          vm.$wlToastr(
            'error',
            vm.$t('myprofile.update.error'),
            vm.$t('UserProfile_MyProfile').toString(),
          );
          return;
        }
        await vxm.users.validateMandatorySteps();
        if(vxm.users.MissedMandatorySteps.length && this.isLastStep) {
          this.$emit('missed-mandatory', vxm.users.MissedMandatorySteps);
        }else{
          this.$emit('go-to-next');
        }
        this.viewMode = true;
        this.selectedLanguage = this.userSelectedLanguages;
        vxm.users.Rudderstack.trackEvent("Languages Updated", { Languages: this.selectedLanguage });
        vxm.users.getProfileStrength();
      })
      .catch((e) => {
        vm.$wlToastr(
          'error',
          vm.$t('myprofile.update.error'),
          vm.$t('UserProfile_MyProfile').toString(),
        );
      });
  }

  fetchAllLanguages() {
    const vm = this;
    const respPromise: any = vxm.users.fetchLanguages();
    Promise.all([respPromise])
      .then((values) => {
        if (values[0].meta.success === true && Array.isArray(values[0].data)) {
          this.languageArray = values[0].data.map((data) => data.value);
        }
      })
      .catch((e) => {
        vm.$wlToastr(
          'error',
          vm.$t('myprofile.fetch.language.error'),
          vm.$t('UserProfile_MyProfile').toString(),
        );
      });
  }

  fetchSelectedLanguages() {
    const vm = this;
    const respPromise: any = vxm.users.fetchSelectedLanguages();
    Promise.all([respPromise])
      .then((values) => {
        if (values[0].meta.success === true) {
          this.selectedLanguage = values[0].data.languages || []; 
          this.userSelectedLanguages = [...this.selectedLanguage];
        }
      })
      .catch((e) => {
        vm.$wlToastr(
          'error',
          vm.$t('myprofile.fetch.language.error'),
          vm.$t('UserProfile_MyProfile').toString(),
        );
      });
  }
}
